var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.value,"type":"number","label":_vm.label,"rules":_vm.rules},on:{"change":_vm.change,"keypress":function($event){return _vm.isNumber($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }